import React, { Suspense, useEffect } from 'react';
import PortalLoader from './components/PortalLoader';
import LoadingBar from './components/portals/LoadingBar';
import { useCart } from './hooks/useCart';
import CONSTANTS from './_constants';
import { Toast } from './components/portals/Toast';
import { useDispatch } from 'react-redux';

import { dispatchToast } from './store/actions/toast';
import CartCountBadge from './components/portals/CartCountBadge';
import ProductRecommendations from './components/portals/ProductRecommendations/ProductRecommendations';
import CartRecommendations from './components/portals/ProductRecommendations/CartRecommendations';

import MiniCart from './components/portals/MiniCart/index'
import QuickAdd from './components/portals/QuickAdd/index'
import RecentlyViewed from './components/portals/RecentlyViewed/index';

import SearchInput from './components/portals/Search/SearchInput'
import SearchResultsSuggestions from './components/portals/Search/SearchResultsSuggestions'
import SearchResultsCollections from './components/portals/Search/SearchResultsCollections'
import SearchResultsProducts from './components/portals/Search/SearchResultsProducts';
import SearchFilters from './components/portals/Search/SearchFilters';
import SearchFilteredProducts from './components/portals/Search/SearchFilteredProducts';
import {SearchProvider} from './context/search/useSearch';
import SearchSubmit from './components/portals/Search/SearchSubmit';
import SearchFilterCount from './components/portals/Search/SearchFilterCount';
import SearchSortBy from './components/portals/Search/SearchSortBy';
import SearchResultsPages from './components/portals/Search/SearchResultsPages';

import SubBuilder from './components/portals/SubBuilder';
import { SubBuilderProvider } from './context/subBuilder/useSubBuilder';

import WishListProducts from './components/portals/WishListProducts'
import SimpleSubPortal from './components/portals/SimpleSubBuilder';

type AppProps = {
  config: any,
}

export const App: React.FC<AppProps> = ({ config }) => {

  const dispatch = useDispatch();

  const { getCartState, setDOMHelpers, cart } = useCart();

  useEffect(() => {
    getCartState()
  }, []);

  useEffect(() => {
    setDOMHelpers()
  },[cart])

  window['blubolt'].dispatchToast = (type: string, data: any) => dispatch(dispatchToast(type, data));

  return (
    <div>
      <Suspense fallback={<div>Loading...</div>}>
        <PortalLoader
          dataAttr={CONSTANTS.PORTALS.LOADING}
          Component={LoadingBar}
        />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <PortalLoader
          dataAttr={CONSTANTS.PORTALS.TOAST}
          Component={Toast}
        />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <PortalLoader
          dataAttr={CONSTANTS.PORTALS.CART_COUNT_BADGE}
          Component={CartCountBadge}
        />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <PortalLoader
          dataAttr={CONSTANTS.PORTALS.RECENTLY_VIEWED}
          Component={RecentlyViewed}
        />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <PortalLoader
          dataAttr={CONSTANTS.PORTALS.PRODUCT_RECOMMENDATIONS}
          Component={ProductRecommendations}
        />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <PortalLoader
          dataAttr={CONSTANTS.PORTALS.CART_RECOMMENDATIONS}
          Component={CartRecommendations}
        />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <PortalLoader
          dataAttr={CONSTANTS.PORTALS.MINICART}
          Component={MiniCart}
        />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <PortalLoader
          dataAttr={CONSTANTS.PORTALS.QUICKADD}
          Component={QuickAdd}
        />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <PortalLoader
          dataAttr={CONSTANTS.PORTALS.WISHLIST_PRODUCTS}
          Component={WishListProducts}
        />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <PortalLoader
          dataAttr={CONSTANTS.PORTALS.SIMPLE_SUB_BUILDER}
          Component={SimpleSubPortal}
        />
      </Suspense>
      <SubBuilderProvider>
        <Suspense fallback={<div>Loading...</div>}>
          <PortalLoader
            dataAttr={CONSTANTS.PORTALS.SUB_BUILDER}
            Component={SubBuilder}
          />
        </Suspense>
      </SubBuilderProvider>
      { config.appLayerConfigSearch
        && config.appLayerConfigSearchProductsPerPage
        && config.appLayerConfigSearchLoadMoreMode
        && <SearchProvider
          config={{ ...config.appLayerConfigSearch, rProductsPerPage: config.appLayerConfigSearchProductsPerPage, rLoadMoreMode: config.appLayerConfigSearchLoadMoreMode, searchFilterDummyTag: config.appLayerConfigSearchFilterDummyTag}}
          activeCollection={{
            id: config.appLayerConfigActiveCollectionId ?? null,
            title: config.appLayerConfigActiveCollectionTitle ?? null,
            handle: config.appLayerConfigActiveCollectionHandle ?? null,
          }}>
          <Suspense fallback={<div>Loading...</div>}>
            <PortalLoader
              dataAttr={CONSTANTS.PORTALS.SEARCH_INPUT}
              Component={SearchInput}
            />
          </Suspense>
          <Suspense fallback={<div>Loading...</div>}>
            <PortalLoader
              dataAttr={CONSTANTS.PORTALS.SEARCH_SUBMIT}
              Component={SearchSubmit}
            />
          </Suspense>
          <Suspense fallback={<div>Loading...</div>}>
            <PortalLoader
              dataAttr={CONSTANTS.PORTALS.SEARCH_SUGGESTIONS}
              Component={SearchResultsSuggestions}
            />
          </Suspense>
          <Suspense fallback={<div>Loading...</div>}>
            <PortalLoader
              dataAttr={CONSTANTS.PORTALS.SEARCH_COLLECTIONS}
              Component={SearchResultsCollections}
            />
          </Suspense>
          <Suspense fallback={<div>Loading...</div>}>
            <PortalLoader
              dataAttr={CONSTANTS.PORTALS.SEARCH_PAGES}
              Component={SearchResultsPages}
            />
          </Suspense>
          <Suspense fallback={<div>Loading...</div>}>
            <PortalLoader
              dataAttr={CONSTANTS.PORTALS.SEARCH_PRODUCTS}
              Component={SearchResultsProducts}
            />
          </Suspense>
          <Suspense fallback={<div>Loading...</div>}>
            <PortalLoader
              dataAttr={CONSTANTS.PORTALS.SEARCH_FILTERS}
              Component={SearchFilters}
            />
          </Suspense>
          <Suspense fallback={<div>Loading...</div>}>
            <PortalLoader
              dataAttr={CONSTANTS.PORTALS.SEARCH_FILTERED_PRODUCTS}
              Component={SearchFilteredProducts}
            />
          </Suspense>
          <Suspense fallback={<div>Loading...</div>}>
            <PortalLoader
              dataAttr={CONSTANTS.PORTALS.SEARCH_FILTER_COUNT}
              Component={SearchFilterCount}
            />
          </Suspense>
          <Suspense fallback={<div>Loading...</div>}>
            <PortalLoader
              dataAttr={CONSTANTS.PORTALS.SEARCH_SORT_BY}
              Component={SearchSortBy}
            />
          </Suspense>
        </SearchProvider>
      }
    </div>
  )
}

export default App;
